import request from '@/utils/request.js'
// 商品下单
export const goodsOrder = data => {
  return request({
    method: 'POST',
    url: '/mopa/api-pay/open/weixin/native/order/create',
    data
  })
}
// 获取商品支付状态
export const getPayInof = outTradeNo => {
  return request({
    method: 'GET',
    url: '/mopa/api-pay/open/weixin/native/order/info',
    params: {
      outTradeNo
    }
  })
}
